/**
 * Проверка reason на лимит соединений
 */
export const isConnectionLimitError = (reason: string): boolean => {
  if (!reason) return false;

  const lowerReason = reason.toLowerCase();
  return (
    lowerReason.includes('слишком много соединений') ||
    lowerReason.includes('максимально возможное число') ||
    lowerReason.includes('too many connections') ||
    lowerReason.includes('connection limit') ||
    lowerReason.includes('10')
  );
};
